import React from "react";
import {MDBRow} from "mdb-react-ui-kit";


export default function About() {
	return (
		<MDBRow className={'m-4'} id={'section-about'}>
			<p className={'display-6'} style={{textAlign: 'justify'}}>Kościół św. Mikołaja w Przybynowie jest zabytkowym katolickim kościółem parafialnym zlokalizowanym w Przybynowie w województwie śląskim, w powiecie Myszkowskim</p>
		</MDBRow>
	)
}